<template>
  <div class="ordermanagementDetail">
    <div class="translateMian">
      <div class="topBack">
        <el-page-header v-if="isShowBack" @back="goBack1" content="订单详情">
        </el-page-header>
        <el-page-header v-else @back="goBack" content="订单详情">
        </el-page-header>
      </div>
    </div>
    <div class="main">
      <el-button size="mini" v-if="xmOrderInfo.unpaid_amount != 0" @click="collection">继续收款</el-button>
      <el-button size="mini" v-if="
          xmOrderInfo.state != 3 &&
            xmOrderInfo.type != 6 &&
            xmOrderInfo.type != 7
        " @click="cancel">作废订单</el-button>
      <!-- <el-button size="mini">操作日志</el-button>-->
      <div style="margin-top: 15px;" class="boederBox">
        <div class="picIcon">
          <img v-if="xmOrderInfo.state == 1" src="https://wugecdn.steam.fun/resources/static/daibujiao.png" style="width:80px;height:80px" />
          <img v-if="xmOrderInfo.state == 2" src="https://wugecdn.steam.fun/resources/static/yizhifu.png" style="width:80px;height:80px" />
          <img v-if="xmOrderInfo.state == 3" src="https://wugecdn.steam.fun/resources/static/yizuofei.png" style="width:80px;height:80px" />
        </div>
        <div>
          <span style="font-size: 14px;font-weight: bold;">订单号： {{ xmOrderInfo.code }}</span>
        </div>
        <div style="margin-top:10px">
          <span style="font-size: 14px;">创建时间： {{ xmOrderInfo.created_time }}</span>
          <span style="font-size: 14px; margin-left: 15px;">订单类型：
            <span v-if="xmOrderInfo.type === 1">报名</span>
            <span v-if="xmOrderInfo.type === 2">转课</span>
            <span v-if="xmOrderInfo.type === 3">退课</span>
            <span v-if="xmOrderInfo.type === 4">退物品</span>
            <span v-if="xmOrderInfo.type === 5">退费用</span>
            <span v-if="xmOrderInfo.type === 6">账户充值</span>
            <span v-if="xmOrderInfo.type === 7">账户退款</span>
          </span>
          <!-- <span style="font-size: 14px;margin-left: 15px;">订单来源： </span> -->
        </div>
        <div style="margin-top: 15px;" class="boederBox1">
          <ul style="overflow: hidden;">
            <li v-if="xmOrderInfo.type == 7 || xmOrderInfo.type == 6" class="fl" style="width: 33%;">
              <div>充值账户：{{ xmOrderInfo.xm_account_no }}</div>
            </li>
            <li v-if="xmOrderInfo.type == 7 || xmOrderInfo.type == 6" class="fl" style="width: 33%;">
              <div>关联学员：{{ xmOrderInfo.xm_account_stu_str }}</div>
            </li>
            <li v-if="xmOrderInfo.type != 7 && xmOrderInfo.type != 6" class="fl" style="width: 33%;">
              学员姓名：{{ xmOrderInfo.stu_name }}
            </li>
            <li v-if="xmOrderInfo.type === 1" class="fl" style="width: 33%;">
              应收金额(元)：￥{{ xmOrderInfo.total_amount.toFixed(2) }}
            </li>
            <li v-if="xmOrderInfo.type === 1" class="fl" style="width: 33%;">
              实收金额(元)： ￥{{ xmOrderInfo.final_amount.toFixed(2) }}
            </li>
            <li v-if="xmOrderInfo.type === 1" class="fl" style="width: 33%;">
              欠费金额(元)： ￥{{ xmOrderInfo.unpaid_amount.toFixed(2) }}
            </li>
            <li class="fl" v-if="
                xmOrderInfo.type === 3 ||
                  xmOrderInfo.type === 4 ||
                  xmOrderInfo.type === 5 ||
                  xmOrderInfo.type === 7
              " style="width: 33%;">
              应退金额(元)： ￥{{ xmOrderInfo.total_amount.toFixed(2) }}
            </li>
            <li class="fl" style="width: 33%;">
              经办日期：{{ xmOrderInfo.deal_date }}
            </li>
            <li class="fl" v-if="
                xmOrderInfo.type === 3 ||
                  xmOrderInfo.type === 4 ||
                  xmOrderInfo.type === 5 ||
                  xmOrderInfo.type === 7
              " style="width: 33%;">
              实退金额(元)： ￥{{ xmOrderInfo.final_amount.toFixed(2) }}
            </li>
            <li class="fl" style="width: 33%;">
              经办人：{{ xmOrderInfo.deal_user_realname }}
            </li>
            <li class="fl" style="width: 33%;">
              手机号：{{ xmOrderInfo.stu_parent_a_phone_num }}
            </li>
            <li class="fl" style="width: 33%;" @click="showEdit">
              对内备注：
              <span style="display:inline-block;max-width:100px;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:bottom">{{ xmOrderInfo.in_remark||'--' }}</span>
              <span style="color:#2AC250;cursor: pointer;">查看</span>
            </li>
            <li class="fl" style="width: 33%; cursor: pointer;">
              业绩归属人：{{ xmOrderInfo.belong_user_str
              }}<span style="color:#2AC250;cursor: pointer;margin-left:5px;" @click="editPerformance">修改</span>
            </li>
            <li class="fl" style="width: 33%;">
              对外备注：
              <span style="display:inline-block;max-width:100px;overflow: hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:bottom">{{ xmOrderInfo.out_remark || '--' }}</span>
              <span style="color:#2AC250;cursor: pointer;" @click="editOutRemark">
                查看</span>
            </li>
          </ul>
        </div>
      </div>
      <div style="margin-top:15px" v-if="isShowcancel">
        <div>作废信息</div>
        <div style="margin-top:15px">
          <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="cancelList" style="width: 100%">
            <el-table-column prop="" label="作废时间">
              <template slot-scope="scope">{{
                scope.row.disable_date
              }}</template>
            </el-table-column>
            <el-table-column prop="" label="作废人">
              <template slot-scope="scope">{{
                scope.row.disable_user_realname
              }}</template>
            </el-table-column>
            <el-table-column prop="" label="作废原因">
              <template slot-scope="scope">
                <span v-if="scope.row.disable_type === 1">重复录入</span>
                <span v-if="scope.row.disable_type === 2">信息填错</span>
                <span v-if="scope.row.disable_type === 3">其他</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="备注">
              <template slot-scope="scope">{{
                scope.row.disable_remark
              }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="xmOrderInfo.type === 1">
        <div style="margin-top:15px" class="boederBox">
          <div>购买内容</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderGoodsArr" style="width: 100%">
              <el-table-column prop="" label="购买项目">
                <template slot-scope="scope">{{
                  scope.row.goods_name
                }}</template>
              </el-table-column>
              <!-- <el-table-column prop="" label="原订单号" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span style="color: #2AC250; cursor: pointer;">{{ scope.row.relatedXmOrder_code }}</span>
                            </template>
                        </el-table-column> -->
              <el-table-column prop="" label="定价标准">
                <template slot-scope="scope">
                  <span v-if="scope.row.project_type === 1">
                    <span v-for="(item, index) in JSON.parse(scope.row.rule_price)" :key="index">
                      {{ item.unit_price.toFixed(2) }} / 课时
                    </span>
                  </span>
                  <span v-else>{{ scope.row.rule_price }} / 件</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="购买数量">
                <template slot-scope="scope">{{ scope.row.buy_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="总价(元)">
                <template slot-scope="scope">
                  <span v-if="scope.row.project_type === 1">
                    <span v-for="(item, index) in JSON.parse(scope.row.rule_price)" :key="index">
                      ￥ {{ (item.unit_price * scope.row.buy_num).toFixed(2) }}
                    </span>
                  </span>
                  <span v-else>
                    ￥
                    {{ (scope.row.rule_price * scope.row.buy_num).toFixed(2) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="赠送数量">
                <template slot-scope="scope">{{ scope.row.give_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="直减/折扣">
                <template slot-scope="scope">
                  <span v-if="scope.row.discount_type == 1">直减 ￥ {{ scope.row.discount_num.toFixed(2) }}</span>
                  <span v-if="scope.row.discount_type == 2">折扣 {{ scope.row.discount_num }}%</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="小计(元)">
                <template slot-scope="scope">￥{{ scope.row.total_amount.toFixed(2) }}</template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">应收金额(元)：￥{{ sum.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top:20px" class="boederBox">
          <div>支付记录</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderPayRecordArr" style="width: 100%">
              <el-table-column prop="" label="支付时间" show-overflow-tooltip width="200">
                <template slot-scope="scope">{{
                  scope.row.created_time
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办人">
                <template slot-scope="scope">{{
                  scope.row.deal_user_realname
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.deal_date.slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="项目">
                <template slot-scope="scope">
                  <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                  <span v-if="scope.row.bussiness_type === 2">转课</span>
                  <span v-if="scope.row.bussiness_type === 3">退课</span>
                  <span v-if="scope.row.bussiness_type === 4">退物品</span>
                  <span v-if="scope.row.bussiness_type === 5">退费用</span>
                  <span v-if="scope.row.bussiness_type === 6">账户充值</span>
                  <span v-if="scope.row.bussiness_type === 7">账户退款</span>
                  <span v-if="scope.row.bussiness_type === 8">补交</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="支付方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_type === 1">支付宝</span>
                  <span v-if="scope.row.pay_type === 2">微信</span>
                  <span v-if="scope.row.pay_type === 3">现金</span>
                  <span v-if="scope.row.pay_type === 4">网银转账</span>
                  <span v-if="scope.row.pay_type === 6">账户充值</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="支付金额(元)">
                <template slot-scope="scope">
                  ￥{{
                    (scope.row.final_amount + scope.row.give_amount).toFixed(2)
                  }}
                  <span v-if="scope.row.pay_type === 6">
                    <el-tooltip placement="top">
                      <div slot="content">
                        <div>充值账户：{{ xmOrderInfo.stu_username }}</div>
                        <div style="margin-top: 10px;">
                          充值账户支付(元): ￥{{
                            scope.row.final_amount.toFixed(2)
                          }}
                        </div>
                        <div style="margin-top: 10px;">
                          赠送金额抵扣(元): ￥{{
                            scope.row.give_amount.toFixed(2)
                          }}
                        </div>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="凭证">
                <template slot-scope="scope">
                  <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                </template>
              </el-table-column>
              <!--
                            <el-table-column prop="" label="支付流水号">
                            </el-table-column>
                            <el-table-column prop="" label="操作">
                            </el-table-column>
                            -->
            </el-table>
          </div>
        </div>
      </div>
      <div v-if="xmOrderInfo.type === 2">
        <div style="margin-top:15px">
          <div>转出信息</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="TransferOutInformation" style="width: 100%">
              <el-table-column prop="" label="转出课程">
                <template slot-scope="scope">{{
                  scope.row.goods_name
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="原订单号" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button @click="changeOrder(scope.row)" type="text" size="mini">{{ scope.row.relatedXmOrder_code }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="" label="单价">
                <template slot-scope="scope">
                  <span v-for="(item, index) in JSON.parse(scope.row.rule_price)" :key="index">
                    {{ item.unit_price }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="转出购买数量">
                <template slot-scope="scope">{{ scope.row.buy_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="转出赠送数量">
                <template slot-scope="scope">{{ scope.row.give_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="手续费/亏损费">
                <template slot-scope="scope">
                  <div v-if="scope.row.drop_leave_amount > 0" style="color: #2AC250;">
                    <div>￥{{ scope.row.drop_leave_amount.toFixed(2) }}</div>
                    <div>(手续费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount == 0">
                    ￥{{ scope.row.drop_leave_amount.toFixed(2) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="" label="转出金额(元)">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">转出合计(元)：￥{{ sum1.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top:15px">
          <div>转入信息</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="TransferInformationList" style="width: 100%">
              <el-table-column prop="" label="购买项目">
                <template slot-scope="scope">{{
                  scope.row.goods_name
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="定价标准">
                <template slot-scope="scope">
                  <span v-if="scope.row.project_type === 1">
                    <span v-for="(item, index) in JSON.parse(scope.row.rule_price)" :key="index">
                      {{ item.unit_price.toFixed(2) }} / 课时
                    </span>
                  </span>
                  <span v-else>{{ scope.row.rule_price }} / 件</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="购买数量">
                <template slot-scope="scope">{{ scope.row.buy_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="总价(元)">
                <template slot-scope="scope">
                  <span v-if="scope.row.project_type === 1">
                    <span v-for="(item, index) in JSON.parse(scope.row.rule_price)" :key="index">
                      ￥{{ (item.unit_price * scope.row.buy_num).toFixed(2) }}
                    </span>
                  </span>
                  <span v-else>￥{{
                      (scope.row.rule_price * scope.row.buy_num).toFixed(2)
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="赠送数量">
                <template slot-scope="scope">{{ scope.row.give_num }}</template>
              </el-table-column>

              <el-table-column prop="" label="直减/折扣">
                <template slot-scope="scope">
                  <span v-if="scope.row.discount_type == 1">直减 ￥ {{ scope.row.discount_num.toFixed(2) }}</span>
                  <span v-if="scope.row.discount_type == 2">折扣 {{ scope.row.discount_num }}%</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="小计(元)">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">转入合计(元)：￥{{ sum2.toFixed(2) }}</div>
            </div>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">
                应退金额(元)：￥{{ (sum1 + sum2).toFixed(2) }}
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:15px">
          <div>退款记录</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderPayRecordArr" style="width: 100%">
              <el-table-column prop="" label="退款时间" show-overflow-tooltip>
                <template slot-scope="scope">{{
                  scope.row.created_time
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办人">
                <template slot-scope="scope">{{
                  scope.row.deal_user_realname
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.deal_date.slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="项目">
                <template slot-scope="scope">
                  <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                  <span v-if="scope.row.bussiness_type === 2">转课</span>
                  <span v-if="scope.row.bussiness_type === 3">退课</span>
                  <span v-if="scope.row.bussiness_type === 4">退物品</span>
                  <span v-if="scope.row.bussiness_type === 5">退费用</span>
                  <span v-if="scope.row.bussiness_type === 6">账户充值</span>
                  <span v-if="scope.row.bussiness_type === 7">账户退款</span>
                  <span v-if="scope.row.bussiness_type === 8">补交</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_type === 1">支付宝</span>
                  <span v-if="scope.row.pay_type === 2">微信</span>
                  <span v-if="scope.row.pay_type === 3">现金</span>
                  <span v-if="scope.row.pay_type === 4">网银转账</span>

                  <span v-else>充值账户</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款金额(元)">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="凭证">
                <template slot-scope="scope">
                  <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="" label="退款流水号"> </el-table-column>
                            <el-table-column prop="" label="退款状态"> </el-table-column>
                            <el-table-column prop="" label="收支状态"> </el-table-column>
                            <el-table-column prop="" label="操作"> </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
      <div v-if="xmOrderInfo.type === 3">
        <div style="margin-top:15px">
          <div>退课信息</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderGoodsArr" style="width: 100%">
              <el-table-column prop="" label="退出物品">
                <template slot-scope="scope">{{
                  scope.row.goods_name
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="原订单号" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button @click="changeOrder(scope.row)" type="text" size="mini">{{ scope.row.relatedXmOrder_code }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="" label="单价">
                <template slot-scope="scope">
                  <span v-if="scope.row.project_type === 1">
                    <span v-for="(item, index) in JSON.parse(scope.row.rule_price)" :key="index">
                      {{ item.unit_price }} / 课时
                    </span>
                  </span>
                  <span v-else>{{ scope.row.rule_price }} / 件</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退出购买数量">
                <template slot-scope="scope">{{ scope.row.buy_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="退出赠送数量">
                <template slot-scope="scope">{{ scope.row.give_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="退出金额">
                <template slot-scope="scope">
                  ￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="手续费/亏损费">
                <template slot-scope="scope">
                  <div v-if="scope.row.drop_leave_amount > 0" style="color: #2AC250;">
                    <div>￥ {{ scope.row.drop_leave_amount.toFixed(2) }}</div>
                    <div>(手续费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount < 0" style="color: #f00;">
                    <div>
                      ￥
                      {{ scope.row.drop_leave_amount.toString().substring(1) }}
                    </div>
                    <div>(亏损费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount == 0">
                    ￥ {{ scope.row.drop_leave_amount.toFixed(2) }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">应退金额：￥{{ sum.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top:15px">
          <div>退款记录</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderPayRecordArr" style="width: 100%">
              <el-table-column prop="" label="退款时间" show-overflow-tooltip>
                <template slot-scope="scope">{{
                  scope.row.created_time
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办人">
                <template slot-scope="scope">{{
                  scope.row.deal_user_realname
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.deal_date.slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="项目">
                <template slot-scope="scope">
                  <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                  <span v-if="scope.row.bussiness_type === 2">转课</span>
                  <span v-if="scope.row.bussiness_type === 3">退课</span>
                  <span v-if="scope.row.bussiness_type === 4">退物品</span>
                  <span v-if="scope.row.bussiness_type === 5">退费用</span>
                  <span v-if="scope.row.bussiness_type === 6">账户充值</span>
                  <span v-if="scope.row.bussiness_type === 7">账户退款</span>
                  <span v-if="scope.row.bussiness_type === 8">补交</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_type === 1">支付宝</span>
                  <span v-if="scope.row.pay_type === 2">微信</span>
                  <span v-if="scope.row.pay_type === 3">现金</span>
                  <span v-if="scope.row.pay_type === 4">网银转账</span>
                  <span v-if="scope.row.pay_type === 6">账户</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款金额(元)">
                <template slot-scope="scope">
                  ￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="凭证">
                <template slot-scope="scope">
                  <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                </template>
              </el-table-column>
              <!--
                            <el-table-column prop="" label="支付流水号">
                            </el-table-column>
                            <el-table-column prop="" label="操作">
                            </el-table-column>
                            -->
            </el-table>
          </div>
        </div>
      </div>
      <div v-if="xmOrderInfo.type === 4">
        <div style="margin-top:15px">
          <div>退出物品</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderGoodsArr" style="width: 100%">
              <el-table-column prop="" label="退出物品">
                <template slot-scope="scope">{{
                  scope.row.goods_name
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="原订单号" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button @click="changeOrder(scope.row)" type="text" size="mini">{{ scope.row.relatedXmOrder_code }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="" label="单价">
                <template slot-scope="scope">
                  <span v-if="scope.row.project_type === 1">
                    <span v-for="(item, index) in JSON.parse(scope.row.rule_price)" :key="index">
                      {{ item.unit_price }} / 课时
                    </span>
                  </span>
                  <span v-else>{{ scope.row.rule_price }} / 件</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退出数量">
                <template slot-scope="scope">{{ scope.row.buy_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="退出金额">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="drop_leave_amount" label="手续费/亏损费">
                <template slot-scope="scope">
                  <div v-if="scope.row.drop_leave_amount > 0" style="color: #2AC250;">
                    <div>￥{{ scope.row.drop_leave_amount.toFixed(2) }}</div>
                    <div>(手续费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount < 0" style="color: #f00;">
                    <div>
                      ￥
                      {{ scope.row.drop_leave_amount.toString().substring(1) }}
                    </div>
                    <div>(亏损费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount == 0">
                    ￥ {{ scope.row.drop_leave_amount.toFixed(2) }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">应退金额：￥{{ sum.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top:15px">
          <div>退款记录</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderPayRecordArr" style="width: 100%">
              <el-table-column prop="" label="退款时间" show-overflow-tooltip>
                <template slot-scope="scope">{{
                  scope.row.created_time
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办人">
                <template slot-scope="scope">{{
                  scope.row.deal_user_realname
                }}</template>
              </el-table-column>
              <el-table-column prop="deal_date" label="经办日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.deal_date.slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="项目">
                <template slot-scope="scope">
                  <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                  <span v-if="scope.row.bussiness_type === 2">转课</span>
                  <span v-if="scope.row.bussiness_type === 3">退课</span>
                  <span v-if="scope.row.bussiness_type === 4">退物品</span>
                  <span v-if="scope.row.bussiness_type === 5">退费用</span>
                  <span v-if="scope.row.bussiness_type === 6">账户充值</span>
                  <span v-if="scope.row.bussiness_type === 7">账户退款</span>
                  <span v-if="scope.row.bussiness_type === 8">补交</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_type === 1">支付宝</span>
                  <span v-if="scope.row.pay_type === 2">微信</span>
                  <span v-if="scope.row.pay_type === 3">现金</span>
                  <span v-if="scope.row.pay_type === 4">网银转账</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款金额(元)">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="凭证">
                <template slot-scope="scope">
                  <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                </template>
              </el-table-column>
              <!--
                            <el-table-column prop="" label="支付流水号">
                            </el-table-column>
                            <el-table-column prop="" label="操作">
                            </el-table-column>
                            -->
            </el-table>
          </div>
        </div>
      </div>
      <div v-if="xmOrderInfo.type === 5">
        <div style="margin-top:15px">
          <div>退费用信息</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderGoodsArr" style="width: 100%">
              <el-table-column prop="" label="退出费用">
                <template slot-scope="scope">{{
                  scope.row.goods_name
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="原订单号" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button @click="changeOrder(scope.row)" type="text" size="mini">{{ scope.row.relatedXmOrder_code }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="" label="单价">
                <template slot-scope="scope">
                  <span>{{ scope.row.rule_price }} / 笔</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退出数量">
                <template slot-scope="scope">{{ scope.row.buy_num }}</template>
              </el-table-column>
              <el-table-column prop="" label="退出金额">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="drop_leave_amount" label="手续费/亏损费">
                <template slot-scope="scope">
                  <div v-if="scope.row.drop_leave_amount > 0" style="color: #2AC250;">
                    <div>￥{{ scope.row.drop_leave_amount.toFixed(2) }}</div>
                    <div>(手续费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount < 0" style="color: #f00;">
                    <div>
                      ￥{{
                        scope.row.drop_leave_amount.toString().substring(1)
                      }}
                    </div>
                    <div>(亏损费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount == 0">
                    ￥{{ scope.row.drop_leave_amount.toFixed(2) }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">应退金额：￥{{ sum.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top:15px">
          <div>退款记录</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderPayRecordArr" style="width: 100%">
              <el-table-column prop="" label="退款时间" show-overflow-tooltip>
                <template slot-scope="scope">{{
                  scope.row.created_time
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办人">
                <template slot-scope="scope">{{
                  scope.row.deal_user_realname
                }}</template>
              </el-table-column>
              <el-table-column prop="deal_date" label="经办日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.deal_date.slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="项目">
                <template slot-scope="scope">
                  <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                  <span v-if="scope.row.bussiness_type === 2">转课</span>
                  <span v-if="scope.row.bussiness_type === 3">退课</span>
                  <span v-if="scope.row.bussiness_type === 4">退物品</span>
                  <span v-if="scope.row.bussiness_type === 5">退费用</span>
                  <span v-if="scope.row.bussiness_type === 6">账户充值</span>
                  <span v-if="scope.row.bussiness_type === 7">账户退款</span>
                  <span v-if="scope.row.bussiness_type === 8">补交</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_type === 1">支付宝</span>
                  <span v-if="scope.row.pay_type === 2">微信</span>
                  <span v-if="scope.row.pay_type === 3">现金</span>
                  <span v-if="scope.row.pay_type === 4">网银转账</span>
                  <span v-if="scope.row.pay_type === 6">账户</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="退款金额(元)">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="凭证">
                <template slot-scope="scope">
                  <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                </template>
              </el-table-column>
              <!--
                            <el-table-column prop="" label="支付流水号">
                            </el-table-column>
                            <el-table-column prop="" label="操作">
                            </el-table-column>
                            -->
            </el-table>
          </div>
        </div>
      </div>
      <div v-if="xmOrderInfo.type === 6">
        <div style="margin-top:15px">
          <div>购买内容</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderGoodsArr" style="width: 100%">
              <el-table-column prop="" label="实充余额">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="赠送余额">
                <template slot-scope="scope">￥{{ scope.row.give_num.toFixed(2) }}</template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">应收金额(元)：￥{{ sum.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top:15px">
          <div>支付记录</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderPayRecordArr" style="width: 100%">
              <el-table-column prop="" label="支付时间" show-overflow-tooltip>
                <template slot-scope="scope">{{
                  scope.row.created_time
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办人">
                <template slot-scope="scope">{{
                  scope.row.deal_user_realname
                }}</template>
              </el-table-column>
              <el-table-column prop="deal_date" label="经办日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.deal_date.slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="项目">
                <template slot-scope="scope">
                  <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                  <span v-if="scope.row.bussiness_type === 2">转课</span>
                  <span v-if="scope.row.bussiness_type === 3">退课</span>
                  <span v-if="scope.row.bussiness_type === 4">退物品</span>
                  <span v-if="scope.row.bussiness_type === 5">退费用</span>
                  <span v-if="scope.row.bussiness_type === 6">账户充值</span>
                  <span v-if="scope.row.bussiness_type === 7">账户退款</span>
                  <span v-if="scope.row.bussiness_type === 8">补交</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="支付方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_type === 1">支付宝</span>
                  <span v-if="scope.row.pay_type === 2">微信</span>
                  <span v-if="scope.row.pay_type === 3">现金</span>
                  <span v-if="scope.row.pay_type === 4">网银转账</span>
                  <span v-if="scope.row.pay_type === 6">账户充值</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="支付金额(元)">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="凭证">
                <template slot-scope="scope">
                  <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                </template>
              </el-table-column>
              <!--
                            <el-table-column prop="" label="支付流水号">
                            </el-table-column>
                            <el-table-column prop="" label="操作">
                            </el-table-column>
                            -->
            </el-table>
          </div>
        </div>
      </div>
      <div v-if="xmOrderInfo.type === 7">
        <div style="margin-top:15px">
          <div>退款信息</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderGoodsArr" style="width: 100%">
              <el-table-column prop="" label="实充余额">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="赠送余额">
                <template slot-scope="scope">￥{{ scope.row.give_num.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="drop_leave_amount" label="手续费/亏损费">
                <template slot-scope="scope">
                  <div v-if="scope.row.drop_leave_amount > 0" style="color: #2AC250;">
                    <div>￥{{ scope.row.drop_leave_amount.toFixed(2) }}</div>
                    <div>(手续费)</div>
                  </div>
                  <div v-if="scope.row.drop_leave_amount == 0">
                    ￥{{ scope.row.drop_leave_amount.toFixed(2) }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top:15px;overflow:hidden">
              <div class="fr">应收金额(元)：￥{{ sum.toFixed(2) }}</div>
            </div>
          </div>
        </div>
        <div style="margin-top:15px">
          <div>支付记录</div>
          <div style="margin-top:15px">
            <el-table :header-cell-style="{ background: '#f5f7fa' }" :data="xmOrderInfo.xmOrderPayRecordArr" style="width: 100%">
              <el-table-column prop="" label="支付时间" show-overflow-tooltip>
                <template slot-scope="scope">{{
                  scope.row.created_time
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办人">
                <template slot-scope="scope">{{
                  scope.row.deal_user_realname
                }}</template>
              </el-table-column>
              <el-table-column prop="" label="经办日期" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.deal_date.slice(0, 10) }}
                </template>
              </el-table-column>
              <el-table-column prop="" label="项目">
                <template slot-scope="scope">
                  <span v-if="scope.row.bussiness_type === 1">报名/续费</span>
                  <span v-if="scope.row.bussiness_type === 2">转课</span>
                  <span v-if="scope.row.bussiness_type === 3">退课</span>
                  <span v-if="scope.row.bussiness_type === 4">退物品</span>
                  <span v-if="scope.row.bussiness_type === 5">退费用</span>
                  <span v-if="scope.row.bussiness_type === 6">账户充值</span>
                  <span v-if="scope.row.bussiness_type === 7">账户退款</span>
                  <span v-if="scope.row.bussiness_type === 8">补交</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="支付方式">
                <template slot-scope="scope">
                  <span v-if="scope.row.pay_type === 1">支付宝</span>
                  <span v-if="scope.row.pay_type === 2">微信</span>
                  <span v-if="scope.row.pay_type === 3">现金</span>
                  <span v-if="scope.row.pay_type === 4">网银转账</span>
                  <span v-if="scope.row.pay_type === 6">账户充值</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="支付金额(元)">
                <template slot-scope="scope">￥{{ scope.row.final_amount.toFixed(2) }}</template>
              </el-table-column>
              <el-table-column prop="" label="凭证">
                <template slot-scope="scope">
                  <span @click="lookVoucher(scope.row)" style="color:#2AC250">查看</span>
                </template>
              </el-table-column>
              <!--
                            <el-table-column prop="" label="支付流水号">
                            </el-table-column>
                            <el-table-column prop="" label="操作">
                            </el-table-column>
                            -->
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="编辑备注信息" :visible.sync="dialogVisible1" width="30%">
      <div style="margin-top:15px">
        <el-input type="textarea" :maxlength="200" show-word-limit :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="xmOrderInfo.in_remark">
        </el-input>
      </div>

      <div style="margin-top:15px">
        <el-upload ref="upload" action="" :http-request="uploadFileSchool" :on-remove="handleRemove" :on-change="handleChangeFile" :auto-upload="false" :limit="3" :file-list="xmOrderInfo.in_remark_img" list-type="picture">
          <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
          </el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
          <template slot="file" slot-scope="{file}">
            <el-image style="width:auto; height:100%;" :src="file.url" :preview-src-list="getPicUrlList(xmOrderInfo.in_remark_img)" class="el-upload-list__item-thumbnail">
            </el-image>
            <!-- <img @click="handlePreview(file)" :src="file.url" class="el-upload-list__item-thumbnail"> -->
            <p @click="handlePreview($event,file)" class="el-upload-list__item-name">{{ file.name }}</p>
            <i @click="handleRemove(file)" class="el-icon-close"></i>
          </template>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitInRemark">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="上传凭证" :visible.sync="dialogVisible3" width="30%">
      <div style="margin-top:15px">
        <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove1" :on-change="handleChangeFile1" :auto-upload="false" :limit="3" :file-list="imgList1" list-type="picture">
          <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
          </el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="submitVoucher">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑对外备注信息" :visible.sync="dialogVisible4" width="30%">
      <div style="margin-top:15px">
        <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="xmOrderInfo.out_remark">
        </el-input>
      </div>
      <div style="margin-top:15px">
        <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemoveOut" :on-change="handleChangeFileOut" :auto-upload="false" :limit="3" :file-list="xmOrderInfo.out_remark_img" list-type="picture">
          <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
          </el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
          <template slot="file" slot-scope="{file}">
            <el-image style="width:auto; height:100%;" :src="file.url" :preview-src-list="getPicUrlList(xmOrderInfo.out_remark_img)" class="el-upload-list__item-thumbnail">
            </el-image>
            <!-- <img @click="handlePreview(file)" :src="file.url" class="el-upload-list__item-thumbnail"> -->
            <p @click="handlePreview($event,file)" class="el-upload-list__item-name">{{ file.name }}</p>
            <i @click="handleRemoveOut(file)" class="el-icon-close"></i>
          </template>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="submitOutRemark">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑业绩归属人" :visible.sync="dialogVisible5" width="30%">
      <div style="margin-top:15px">
        <el-select v-model="belongUserIdArr" multiple collapse-tags style="width:100%;" placeholder="请选择">
          <el-option v-for="item in options" :key="item.id" :label="item.realname + '(' + item.name + ')'" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="submitPerformance">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="作废订单" :visible.sync="dialogVisible6" width="50%">
      <div v-if="isShowType">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="作废类型" prop="disable_type">
            <el-select v-model="form.disable_type" placeholder="请选择作废类型" clearable>
              <el-option label="重复录入" value="1"></el-option>
              <el-option label="信息填错" value="2"></el-option>
              <el-option label="其他" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="作废原因">
            <el-input type="textarea" v-model="form.disable_remark" placeholder="可以详细描述为什么作废订单"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <div v-if="isShow">
          <el-steps :active="active" finish-status="success">
            <el-step title="处理课消记录"></el-step>
            <el-step title="作废确认"></el-step>
          </el-steps>
          <div v-if="active === 0" style="margin-top:15px">
            <el-table :data="tableData" style="width: 100%" height="200">
              <el-table-column prop="tchPlanSignData" label="点名时间" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="lessonTitle" label="课程名称">
              </el-table-column>
              <el-table-column prop="className" label="班级名称">
              </el-table-column>
              <el-table-column prop="lecturerName" label="上课老师">
              </el-table-column>
              <el-table-column prop="" label="扣课时">
                <template slot-scope="scope">
                  <span>{{ scope.row.costLessonHour }}</span>
                  <span v-if="scope.row.over_lesson_hour > 0" style="color:#f00">
                    (超上{{ scope.row.over_lesson_hour }}课时)</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top:10px">
              <el-pagination style="text-align:right" @current-change="handleCurrentChange" :current-page.sync="page_no" :page-size="page_size" layout="total, prev, pager, next" :total="total"></el-pagination>
            </div>
          </div>
          <div v-else style="margin-top:15px">
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
              <el-form-item label="作废类型" prop="disable_type">
                <el-select v-model="form.disable_type" placeholder="请选择作废类型" clearable>
                  <el-option label="重复录入" value="1"></el-option>
                  <el-option label="信息填错" value="2"></el-option>
                  <el-option label="其他" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="作废原因">
                <el-input type="textarea" v-model="form.disable_remark" placeholder="可以详细描述为什么作废订单"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-else>
          <el-alert title="以下点名记录标记过【无需补扣】，导致订单无法作废。如需作废，请先至“学员详情-上课记录”删除改点名记录" type="warning" show-icon :closable="false">
          </el-alert>
          <el-table :data="tableData1" style="width: 100%" height="200">
            <el-table-column prop="tchPlanSignData" label="点名时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lessonTitle" label="课程名称">
            </el-table-column>
            <el-table-column prop="className" label="班级名称">
            </el-table-column>
            <el-table-column prop="lecturerName" label="上课老师">
            </el-table-column>
            <el-table-column prop="" label="扣课时" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.costLessonHour }}</span>
                <span v-if="scope.row.over_lesson_hour > 0">
                  (超上{{ scope.row.over_lesson_hour }}课时<span v-if="scope.row.make_up_state == 2">,无需补扣</span>)</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top:10px">
            <el-pagination style="text-align:right" @current-change="handleCurrentChange1" :current-page.sync="page_no1" :page-size="page_size1" layout="total, prev, pager, next" :total="total1"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qx">取 消</el-button>
        <span v-if="isShow" style="margin-left:20px">
          <el-button type="primary" @click="next" v-if="active === 0">标记为超上</el-button>
          <el-button type="primary" @click="cancelBtn('form')" v-else>确认</el-button>
        </span>
        <el-button v-if="isShowType" type="primary" @click="cancelBtn('form')">确 定</el-button>
        <el-button v-if="isShowType === false && isShow === false" type="primary" @click="dialogVisible6 = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 补课 -->
    <el-dialog title="收款" class="bk" :visible.sync="dialogVisible7" width="50%">
      <div class="">
        <div>支付信息</div>
        <div style="margin-top: 10px;">应收金额：￥ {{ sumAmount }}</div>
        <div style="margin-top: 10px;">充值账户抵扣</div>
        <div style="margin-top: 10px;">
          <div style="overflow: hidden;" v-if="xmAccountList.length != 0">
            <div class="fl">
              <el-select @change="changeAccount" v-model="xm_account_id" placeholder="请选择" size="mini" clearable>
                <el-option v-for="item in xmAccountList" :key="item.id" :label="item.account_no" :value="item.id">
                  <span style="float: left">{{ item.account_no }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    余额（ {{ item.amount }} ）</span>
                </el-option>
              </el-select>
              <div style="overflow: hidden;" v-if="xm_account_id != ''">
                <div style="border: 1px solid #ccc;padding: 10px 5px;border-radius: 5px;margin-right: 10px;margin-top: 20px;" class="fl" v-for="(item, index) in paymentType.slice(6, 8)" :key="index">
                  <div style="overflow: hidden;">
                    <div class="fl">
                      <el-checkbox v-model="item.isCheck" @change="chengepaymentType">{{ item.title }}</el-checkbox>
                    </div>
                    <div class="fl" style="margin-left: 10px;">
                      <div v-if="item.isCheck">
                        <el-input type="Number" oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" v-model="item.amountOfMoney" placeholder="请输入内容" size="mini" style="width: 100px;">
                          <span slot="suffix" style="line-height: 28px">
                            元
                          </span>
                        </el-input>
                      </div>
                    </div>
                  </div>
                  <!-- {{ item }} -->
                  <div v-if="item.id == 7">
                    <span>最多可用{{ availableBBalance.amount }}元</span>
                  </div>
                  <div v-if="item.id == 8">
                    <span>最多可用{{ availableBBalance.give_amount }}元</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span v-else>
            此学员未开通充值账户
          </span>
        </div>
        <div style="margin-top: 18px;">其他方式收款</div>
        <div style="margin-top: 18px;">
          <ul style="overflow: hidden;">
            <li class="fl borderpayment" v-for="(item, index) in paymentType.slice(0, 5)" :key="index">
              <div style="overflow: hidden;">
                <div class="fl">
                  <el-checkbox v-model="item.isCheck" @change="chengepaymentType">{{ item.title }}</el-checkbox>
                </div>
                <div class="fr" v-if="item.isCheck">
                  <el-input type="Number" oninput="if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" :disabled="item.disabled" v-model="item.amountOfMoney" @input="$forceUpdate()" placeholder="请输入内容" size="mini" style="width: 100px;">
                    <span slot="suffix" style="line-height: 28px"> 元 </span>
                  </el-input>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 支付宝凭证 -->
        <div v-if="isIdOneAndCheck">
          <div style="margin-top: 18px;">支付宝凭证</div>
          <div style="margin-top: 18px;">
            <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove7" :on-change="handleChangeFile7" :auto-upload="false" :limit="3" :file-list="zfbimgList" list-type="picture">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <span slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </span>
            </el-upload>
          </div>
        </div>
        <!-- 微信凭证 -->
        <div v-if="isIdOneAndCheckvx">
          <div style="margin-top: 18px;">微信凭证</div>
          <div style="margin-top: 18px;">
            <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove2" :on-change="handleChangeFile2" :auto-upload="false" :limit="3" :file-list="wximgList" list-type="picture">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <span slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </span>
            </el-upload>
          </div>
        </div>

        <!-- 现金凭证 -->
        <div v-if="isIdOneAndCheckxj">
          <div style="margin-top: 18px;">现金凭证</div>
          <div style="margin-top: 18px;">
            <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove3" :on-change="handleChangeFile3" :auto-upload="false" :limit="3" :file-list="xjimgList" list-type="picture">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <span slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </span>
            </el-upload>
          </div>
        </div>
        <!-- 网银转账 -->
        <div v-if="isIdOneAndCheckwy">
          <div style="margin-top: 18px;">网银转账</div>
          <div style="margin-top: 18px;">
            <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove4" :on-change="handleChangeFile4" :auto-upload="false" :limit="3" :file-list="wyimgList" list-type="picture">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <span slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </span>
            </el-upload>
          </div>
        </div>
        <!-- Pos机刷卡 -->
        <div v-if="isIdOneAndCheckPos">
          <div style="margin-top: 18px;">Pos机刷卡</div>
          <div style="margin-top: 18px;">
            <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove5" :on-change="handleChangeFile5" :auto-upload="false" :limit="3" :file-list="posimgList" list-type="picture">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <span slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </span>
            </el-upload>
          </div>
        </div>
        <!-- 账户充值 -->
        <div v-if="isIdOneAndCheckzh">
          <div style="margin-top: 18px;">账户充值</div>
          <div style="margin-top: 18px;">
            <el-upload action="" :http-request="uploadFileSchool" :on-remove="handleRemove6" :on-change="handleChangeFile6" :auto-upload="false" :limit="3" :file-list="zhimgList" list-type="picture">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <span slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </span>
            </el-upload>
          </div>
        </div>
        <el-divider></el-divider>
        <div style="overflow: hidden;margin-top: 20px;">
          <div class="fr">
            <div style="text-align: right;">
              实收金额 :
              <span style="font-size: 16px;font-weight: bold;">￥{{ totalAmount }}</span>
            </div>
            <div style="text-align: right;">
              <el-checkbox @change="changeArrearsButton" v-model="checked" v-if="totalAmount - sumAmount < 0"></el-checkbox>
              欠费金额 :
              <span style="font-size: 16px;font-weight: bold;" v-if="totalAmount - sumAmount < 0">
                ￥{{ sumAmount - totalAmount }}</span>
            </div>
            <div v-if="checked === true">
              为统计购买项目的实际收入，请分摊本次欠费的 ￥{{
                sumAmount - totalAmount
              }}
            </div>
          </div>
        </div>
        <el-table v-if="checked === true" :data="tableData2" style="width: 100%;margin-top: 20px;" :header-cell-style="{ background: '#f5f7fa' }">
          <el-table-column prop="goods_name" label="购买项目">
          </el-table-column>
          <el-table-column prop="unpaid_amount" label="应收金额 ">
          </el-table-column>
          <el-table-column prop="" label="分摊欠费金额 ">
            <template slot-scope="scope">
              <span>
                <el-checkbox v-model="scope.row.isChecked" @change="changeAllocatedAmount(scope.row)">{{ scope.row.allocatedAmount }}</el-checkbox>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="实收金额">
            <template slot-scope="scope">
              <span>
                {{ scope.row.paidInAmount }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-form ref="form" :model="form1" size="mini" style="margin-top: 20px;">
          <el-form-item label="经办日期">
            <el-date-picker @change="changeTime" v-model="form1.deal_date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" clearable placement="bottom-start">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible7 = false">取消</el-button>
        <el-button size="small" type="primary" @click="Submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getXmOrderInfo,
  updateXmOrderInRemark,
  uploadXmOrderPayProofImg,
  updateXmOrderOutRemark,
  getCampusUserList,
  updateXmOrderBelongUser,
  disableXmOrder,
  getSignedStuTchPlanForDisableXmOrder,
  getXmOrderGoodsListForPayBack,
  xmPayBack,
} from '@/api/educational'
import uploadFileSchool from '@/config/uploadFileSchool'
import moment from 'moment'

export default {
  data() {
    return {
      isShowBack: false,
      //
      xmAccountList: [],
      availableBBalance: {},
      checked: false,
      zhimgList: [],
      posimgList: [],
      wyimgList: [],
      xjimgList: [],
      wximgList: [],
      zfbimgList: [],
      paymentType: [
        {
          id: '1',
          title: '支付宝',
          isCheck: false,
          proof_img: [],
          amountOfMoney: '',
          disabled: false,
        },
        {
          id: '2',
          title: '微信',
          isCheck: false,
          proof_img: [],
          amountOfMoney: '',
          disabled: false,
        },
        {
          id: '3',
          title: '现金',
          isCheck: false,
          proof_img: [],
          amountOfMoney: '',
          disabled: false,
        },
        {
          id: '4',
          title: '网银转账',
          isCheck: false,
          proof_img: [],
          amountOfMoney: '',
          disabled: false,
        },
        {
          id: '5',
          title: 'Pos机刷卡',
          isCheck: false,
          proof_img: [],
          amountOfMoney: '',
          disabled: false,
        },
        {
          id: '6',
          title: '账户充值',
          isCheck: false,
          proof_img: [],
          amountOfMoney: '',
          disabled: false,
        },
        {
          id: '7',
          title: '实充余额抵扣',
          isCheck: false,
          amountOfMoney: '',
        },
        {
          id: '8',
          title: '赠送余额抵扣',
          isCheck: false,
          amountOfMoney: '',
        },
      ],
      form1: {
        deal_date: '',
      },
      dialogVisible7: false,
      sumAmount: 0,
      tableData2: [],
      //
      isShowcancel: false,
      cancelList: [],
      active: 0,
      form: {},
      isShowType: false,
      isShow: false,
      tableData: [],
      tableData1: [],
      dialogVisible6: false,
      sum1: 0,
      sum2: 0,
      options: [],
      belongUserIdArr: [],
      imgList: [],
      imgList1: [],
      imgList2: [],
      TransferInformationList: [],
      TransferOutInformation: [],
      dialogVisible4: false,
      dialogVisible1: false,
      dialogVisible3: false,
      dialogVisible5: false,
      sum: 0,
      xmOrderInfo: {},
      xmOrderGoodsArr: [],
      page_size: 20,
      page_no: 1,
      total: 0,
      page_size1: 20,
      page_no1: 1,
      total1: 0,
      xm_order_id: '',
      rules: {
        disable_type: [
          { required: true, message: '请选择活动区域', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    isIdOneAndCheck() {
      return this.paymentType.some((item) => item.id === '1' && item.isCheck)
    },
    isIdOneAndCheckvx() {
      return this.paymentType.some((item) => item.id === '2' && item.isCheck)
    },
    isIdOneAndCheckxj() {
      return this.paymentType.some((item) => item.id === '3' && item.isCheck)
    },
    isIdOneAndCheckwy() {
      return this.paymentType.some((item) => item.id === '4' && item.isCheck)
    },
    isIdOneAndCheckPos() {
      return this.paymentType.some((item) => item.id === '5' && item.isCheck)
    },
    isIdOneAndCheckzh() {
      return this.paymentType.some((item) => item.id === '6' && item.isCheck)
    },
    newArr: function () {
      return JSON.parse(JSON.stringify(this.tableData2))
    },
    totalAmount() {
      let amount = 0
      for (let i = 0; i < this.paymentType.length; i++) {
        if (this.paymentType[i].isCheck === true) {
          console.log(this.paymentType[i].amountOfMoney, 5262323)
          amount += parseFloat(this.paymentType[i].amountOfMoney) || 0
        }
      }
      return amount.toFixed(2)
    },
  },
  watch: {},
  mounted() {
    this.xm_order_id = this.$route.query.xm_order_id
    this.form1.deal_date = moment().format('YYYY-MM-DD')

    this.getXmOrderInfo()
  },
  methods: {
    getPicUrlList(list) {
      let urlArr = [];
      list.forEach(item => {
        urlArr.push(item.url)
      })
      return urlArr;
    },
    handlePreview(e, file) {
      console.log(e, file)
      const prevElem = e.target.previousSibling;
      if (prevElem && prevElem.children.length !== 0) {
        prevElem.children[0].click();
      }
    },
    changeOrder(row) {
      console.log(row, 789456)
      this.xm_order_id = row.related_order_id
      this.getXmOrderInfo()
      this.isShowBack = true
    },
    goBack1() {
      this.TransferOutInformation = []
      this.TransferInformationList = []
      this.xm_order_id = this.$route.query.xm_order_id
      this.getXmOrderInfo()
      this.isShowBack = false
    },
    //补交
    Submit() {
      console.log(this.tableData2)
      let xmOrderGoodArr = []
      let payRecordArr = []
      if (this.sumAmount - this.totalAmount != 0) {
        if (this.checked == false) {
          this.tableData2.map((item) => {
            xmOrderGoodArr.push({
              xm_order_goods_id: item.id,
              total_amount: item.unpaid_amount,
              final_amount: this.totalAmount,
            })
          })
        } else {
          this.tableData2.map((item) => {
            xmOrderGoodArr.push({
              xm_order_goods_id: item.id,
              total_amount: item.unpaid_amount,
              final_amount: item.paidInAmount,
            })
          })
        }
      } else {
        console.log(this.tableData2, 454878)
        this.tableData2.map((item) => {
          xmOrderGoodArr.push({
            xm_order_goods_id: item.id,
            total_amount: item.unpaid_amount,
            final_amount: item.unpaid_amount,
          })
        })
      }

      console.log(xmOrderGoodArr)
      this.paymentType.map((item) => {
        if (item.isCheck === true) {
          if (item.id === '8') {
            payRecordArr.push({
              give_amount: item.amountOfMoney,
              xm_account_id: this.xm_account_id,
            })
          } else if (item.id === '7') {
            payRecordArr.push({
              final_amount: item.amountOfMoney,
              xm_account_id: this.xm_account_id,
            })
          } else {
            payRecordArr.push({
              pay_type: item.id,
              final_amount: item.amountOfMoney,
              proof_img: JSON.stringify(item.proof_img),
            })
          }
        }
      })
      console.log(payRecordArr, 4541545)
      let mergedObj = {}
      payRecordArr.map((item) => {
        console.log(item.pay_type, 2323323)
        if (item.pay_type === undefined) {
          mergedObj.xm_account_id = this.xm_account_id
          if (item.final_amount) {
            mergedObj.final_amount = mergedObj.final_amount
              ? (
                Number(mergedObj.final_amount) + Number(item.final_amount)
              ).toString()
              : item.final_amount
          }
          if (item.give_amount) {
            mergedObj.give_amount = mergedObj.give_amount
              ? (
                Number(mergedObj.give_amount) + Number(item.give_amount)
              ).toString()
              : item.give_amount
          }
        }
      })
      let payRecordArr1 = []
      payRecordArr.map((item) => {
        if (item.pay_type != undefined) {
          payRecordArr1.push(item)
        }
      })
      if (Object.keys(mergedObj).length != 0) {
        payRecordArr1.push(mergedObj)
      }
      payRecordArr1.map((item) => {
        console.log(item.xm_account_id, 456323)
        console.log(item.give_amount, 456323)
        if (item.xm_account_id != undefined && item.give_amount === undefined) {
          item.give_amount = 0
        }
      })
      console.log(payRecordArr1, 4646545645)
      let isTrue = false
      payRecordArr1.map((item) => {
        if (
          (item.xm_account_id != undefined &&
            item.final_amount > this.availableBBalance.amount) ||
          item.give_amount > this.availableBBalance.give_amount
        ) {
          console.log(123456, 7896)
          isTrue = true
        } else {
          isTrue = false
        }
      })
      if (isTrue === true) {
        this.$message.warning('账户余额不足')
        return false
      }
      console.log(xmOrderGoodArr, 123456)

      if (this.tableData2.length > 1) {
        if (this.sumAmount - this.totalAmount > 0) {
          if (this.checked == false) {
            this.$message.warning('请选择欠费分担金额')
            return false
          }
        }
      }
      console.log(1231, 78878)
      console.log(payRecordArr1, 78878)
      xmPayBack({
        xmOrderGoodArr: JSON.stringify(xmOrderGoodArr),
        payRecordArr: JSON.stringify(payRecordArr1),
        deal_date: this.form1.deal_date,
        student_user_id: this.xmOrderInfo.student_user_id,
        xm_order_id: this.xmOrderInfo.id,
        total_amount: this.sumAmount,
        final_amount: this.totalAmount,
      }).then((res) => {
        this.dialogVisible7 = false
        this.getXmOrderInfo()
        console.log(res, 41545)
      })
    },
    changeAllocatedAmount(row) {
      const checkedNumArr = this.tableData2.filter(item => item.isChecked)
      if (checkedNumArr.length === 0) { return (row.isChecked = true) }
      // let ischeckNum = 0
      let ischeckfalsesum = 0
      this.tableData2.map((item) => {
        if (item.isChecked === false) {
          item.allocatedAmount = 0.0
          item.paidInAmount = item.unpaid_amount
        } else {
          // ischeckNum += 1
          ischeckfalsesum += Number(item.unpaid_amount)
          this.$nextTick(() => {
            item.allocatedAmount = parseFloat(
              (item.unpaid_amount / ischeckfalsesum) *
              (this.sumAmount - this.totalAmount)
            ).toFixed(2)
            item.paidInAmount = (
              item.unpaid_amount - item.allocatedAmount
            ).toFixed(2)
            this.$nextTick(() => {
              let sumft = 0
              this.tableData2.map((item2) => {
                sumft += parseFloat(item2.allocatedAmount)
              })
              if (
                parseFloat(sumft.toFixed(2)) >
                this.sumAmount - this.totalAmount
              ) {
                this.tableData2.slice(-1)[0].allocatedAmount = (
                  this.tableData2.slice(-1)[0].allocatedAmount -
                  (parseFloat(sumft.toFixed(2)) -
                    (this.sumAmount - this.totalAmount))
                ).toFixed(2)
                this.tableData2.slice(-1)[0].paidInAmount = (
                  parseFloat(this.tableData2.slice(-1)[0].paidInAmount) +
                  (parseFloat(sumft.toFixed(2)) -
                    (this.sumAmount - this.totalAmount))
                ).toFixed(2)
              }
              if (
                parseFloat(sumft.toFixed(2)) <
                this.sumAmount - this.totalAmount
              ) {
                let yue =
                  this.sumAmount -
                  this.totalAmount -
                  parseFloat(sumft.toFixed(2))
                this.tableData2.slice(-1)[0].allocatedAmount =
                  parseFloat(this.tableData2.slice(-1)[0].allocatedAmount) +
                  parseFloat(yue.toFixed(2))
                //this.tableData2.slice(-1)[0].allocatedAmount = (parseFloat(this.tableData2.slice(-1)[0].allocatedAmount) + ((this.sumAmount - this.totalAmount) - parseFloat(sumft.toFixed(2)))).toFixed(2)
                this.tableData2.slice(-1)[0].paidInAmount = (
                  parseFloat(this.tableData2.slice(-1)[0].paidInAmount) -
                  (this.sumAmount -
                    this.totalAmount -
                    parseFloat(sumft.toFixed(2)))
                ).toFixed(2)
              }
            })
          })
        }
      })
    },
    //选中分摊
    changeArrearsButton(row) {
      console.log(row, 789566365)
      if (row === true) {
        this.tableData2.map((item) => {
          if (item.isChecked === true) {
            item.allocatedAmount = parseFloat(
              (item.unpaid_amount / this.sumAmount) *
              (this.sumAmount - this.totalAmount)
            ).toFixed(2)
            item.paidInAmount = (
              item.unpaid_amount - item.allocatedAmount
            ).toFixed(2)
          }
        })
        let sumft = 0
        this.tableData2.map((item2) => {
          sumft += parseFloat(item2.allocatedAmount)
        })
        this.$nextTick(() => {
          console.log(this.tableData2, 4584556)
          if (
            parseFloat(sumft.toFixed(2)) >
            this.sumAmount - this.totalAmount
          ) {
            console.log(1232323, 7879595)
            let yue1 =
              parseFloat(sumft.toFixed(2)) - (this.sumAmount - this.totalAmount)
            console.log(yue1, 4545789)

            this.tableData2.slice(-1)[0].allocatedAmount = (
              this.tableData2.slice(-1)[0].allocatedAmount -
              (parseFloat(sumft.toFixed(2)) -
                (this.sumAmount - this.totalAmount))
            ).toFixed(2)
            this.tableData2.slice(-1)[0].paidInAmount = (
              parseFloat(this.tableData2.slice(-1)[0].paidInAmount) +
              (parseFloat(sumft.toFixed(2)) -
                (this.sumAmount - this.totalAmount))
            ).toFixed(2)
          }
          if (
            parseFloat(sumft.toFixed(2)) <
            this.sumAmount - this.totalAmount
          ) {
            let yue =
              this.sumAmount - this.totalAmount - parseFloat(sumft.toFixed(2))
            this.tableData2.slice(-1)[0].allocatedAmount = (
              parseFloat(this.tableData2.slice(-1)[0].allocatedAmount) +
              parseFloat(yue.toFixed(2))
            ).toFixed(2)
            //this.tableData2.slice(-1)[0].allocatedAmount = (parseFloat(this.tableData2.slice(-1)[0].allocatedAmount) + ((this.sumAmount - this.totalAmount) - parseFloat(sumft.toFixed(2)))).toFixed(2)
            this.tableData2.slice(-1)[0].paidInAmount = (
              parseFloat(this.tableData2.slice(-1)[0].paidInAmount) -
              (this.sumAmount - this.totalAmount - parseFloat(sumft.toFixed(2)))
            ).toFixed(2)
          }
        })
      }
    },
    changeAccount(val) {
      this.xmAccountList.map((item) => {
        if (item.id === val) {
          console.log(item, 545623)
          this.availableBBalance = item
          console.log(this.availableBBalance, 456565)
        }
      })
    },

    changeTime(val) {
      console.log(val, 454656)
      console.log(this.form1.deal_date, 454656)
      if (this.form1.deal_date === null) {
        this.form1.deal_date = ''
      }
      console.log(this.form.deal_date, 454656)
    },
    //选中支付方式
    chengepaymentType(val) {
      console.log(val, 48523)
      let selectedCount = 0
      this.paymentType.forEach((item) => {
        if (item.isCheck) {
          selectedCount++
        }
      })
      if (selectedCount === 1) {
        let checkedItem = this.paymentType.find((item) => item.isCheck) // 获取选中的支付类型
        checkedItem.amountOfMoney = ''
        checkedItem.amountOfMoney += this.sumAmount
        this.paymentType.forEach((item) => {
          if (!item.isCheck) {
            item.amountOfMoney = 0
          }
        })
      }
    },

    //上传凭证 账户充值
    handleRemove6() { },
    async handleChangeFile6(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss6(fileList)
      }
    },
    async uploadFileOss6(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.zhimgList = res
          if (this.zhimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '6') {
                item.proof_img = []

                this.zhimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 pos机
    handleRemove5() { },
    async handleChangeFile5(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss5(fileList)
      }
    },
    async uploadFileOss5(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.posimgList = res
          if (this.posimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '5') {
                item.proof_img = []

                this.posimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 网银
    handleRemove4() { },
    async handleChangeFile4(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss4(fileList)
      }
    },
    async uploadFileOss4(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.wyimgList = res
          if (this.wyimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '4') {
                item.proof_img = []

                this.wyimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 现金
    handleRemove3() { },
    async handleChangeFile3(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss3(fileList)
      }
    },
    async uploadFileOss3(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.xjimgList = res
          if (this.xjimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '3') {
                item.proof_img = []

                this.xjimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 微信
    handleRemove2() { },
    async handleChangeFile2(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss2(fileList)
      }
    },
    async uploadFileOss2(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.wximgList = res
          if (this.wximgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '2') {
                item.proof_img = []

                this.wximgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          console.log(this.paymentType, 2323233)

          this.uploadFileTime = false
        }
      )
    },
    //上传凭证 支付宝
    handleRemove7() { },
    async handleChangeFile7(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss7(fileList)
      }
    },
    async uploadFileOss7(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res, 2323233)
          this.zfbimgList = res
          if (this.zfbimgList.length != 0) {
            this.paymentType.map((item) => {
              if (item.id === '1') {
                item.proof_img = []
                this.zfbimgList.map((item1) => {
                  item.proof_img.push({
                    url: item1.url,
                  })
                })
              }
            })
          }
          console.log(this.paymentType, 2323233)
          this.uploadFileTime = false
        }
      )
    },
    collection() {
      this.paymentType.map((item) => {
        item.isCheck = false
        item.amountOfMoney = ''
      })
      this.checked = false
      console.log(this.xmOrderInfo, 12233)
      this.sumAmount = this.xmOrderInfo.unpaid_amount

      // this.xm_order_id = row.id;
      getXmOrderGoodsListForPayBack({
        xm_order_id: this.xmOrderInfo.id,
      }).then((res) => {
        res.xmOrderGoodsList.map((item) => {
          item.isChecked = true
          item.allocatedAmount = 0
          item.paidInAmount = 0
        })
        this.tableData2 = res.xmOrderGoodsList
      })
      this.dialogVisible7 = true
    },
    //

    qx() {
      this.dialogVisible6 = false
      this.active = 0
    },
    handleCurrentChange(val) {
      this.page_no = val
      getSignedStuTchPlanForDisableXmOrder({
        type: '1',
        xmOrderGoodsArr: JSON.stringify(this.xmOrderGoodsArr),
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.returnDataArr
        this.total = res.total
      })
    },
    handleCurrentChange1(val) {
      this.page_no1 = val
      getSignedStuTchPlanForDisableXmOrder({
        type: '1',
        xmOrderGoodsArr: JSON.stringify(this.xmOrderGoodsArr),
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        this.tableData1 = res.returnDataArr
        this.total1 = res.total
      })
      // this.getSignedStuTchPlanForDisableXmOrder()
    },
    cancelBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.xmOrderInfo.id, 785645)
          disableXmOrder({
            xm_order_id: this.xmOrderInfo.id,
            ...this.form,
          }).then((res) => {
            console.log(res, 4512)
            this.$message.success('作废订单成功！')
            this.getXmOrderInfo()
            this.dialogVisible6 = false
          })
        }
      })
    },
    cancel() {
      // this.getSignedStuTchPlanForDisableXmOrder();
      if (
        this.xmOrderInfo.type === 3 ||
        this.xmOrderInfo.type === 4 ||
        this.xmOrderInfo.type === 5
      ) {
        console.log(1213)
        this.dialogVisible6 = true
        this.isShowType = true
      } else {
        this.getSignedStuTchPlanForDisableXmOrder()
        this.dialogVisible6 = true
      }
    },
    next() {
      if (this.active++ > 1) this.active = 1
    },
    getSignedStuTchPlanForDisableXmOrder() {
      getSignedStuTchPlanForDisableXmOrder({
        type: '1',
        xmOrderGoodsArr: JSON.stringify(this.xmOrderGoodsArr),
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res, 123456)
        this.tableData1 = res.returnDataArr
        this.total1 = res.total
        if (this.tableData1.length === 0) {
          getSignedStuTchPlanForDisableXmOrder({
            type: '2',
            xmOrderGoodsArr: JSON.stringify(this.xmOrderGoodsArr),
            page_no: this.page_no,
            page_size: this.page_size,
          }).then((res) => {
            console.log(res, 123456)
            this.tableData = res.returnDataArr
            this.total = res.total
            if (this.tableData1.length === 0 && this.tableData.length === 0) {
              this.isShowType = true
            } else {
              this.tableData.map((item) => {
                if (item.make_up_state === 2) {
                  this.isShow = false
                } else {
                  this.isShow = true
                }
              })
              this.isShowType = false
            }
          })
        }

        // if (res.returnDataArr.length != 0) {
        //     res.returnDataArr.map((item) => {
        //         if (item.make_up_state === 2) {
        //             this.isShow = false
        //         } else {
        //             this.isShow = true
        //         }
        //     })
        //     this.isShowType = false
        // } else {
        //     this.isShowType = true
        // }

        // this.tableData = res.returnDataArr
        // this.total = res.total
      })
    },
    submitPerformance() {
      updateXmOrderBelongUser({
        xm_order_id: this.xmOrderInfo.id,
        belongUserIdArr: JSON.stringify(this.belongUserIdArr),
      }).then(() => {
        this.getXmOrderInfo()
        this.dialogVisible5 = false
      })
    },
    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.options = res.campusUserList
      })
    },
    editPerformance() {
      if (this.xmOrderInfo.belong_user_id === null) {
        this.belongUserIdArr = []
      } else {
        this.belongUserIdArr = this.xmOrderInfo.belong_user_id
      }

      this.getCampusUserList()
      this.dialogVisible5 = true
    },
    submitOutRemark() {
      updateXmOrderOutRemark({
        xm_order_id: this.xmOrderInfo.id,
        out_remark: this.xmOrderInfo.out_remark,
        out_remark_img: JSON.stringify(this.xmOrderInfo.out_remark_img)
      }).then(() => {
        this.getXmOrderInfo()
        this.dialogVisible4 = false
      })
    },
    editOutRemark() {
      this.dialogVisible4 = true
    },
    lookVoucher() {
      this.dialogVisible3 = true
    },
    submitVoucher() {
      uploadXmOrderPayProofImg({
        xm_order_pay_record_id: this.xmOrderInfo.xmOrderPayRecordArr[0].id,
        proof_img: JSON.stringify(this.imgList1),
      }).then(() => {
        this.getXmOrderInfo()
        this.submitVoucher = false
      })
    },
    submitInRemark() {
      updateXmOrderInRemark({
        xm_order_id: this.xmOrderInfo.id,
        in_remark: this.xmOrderInfo.in_remark,
        in_remark_img: JSON.stringify(this.xmOrderInfo.in_remark_img),
      }).then(() => {
        this.getXmOrderInfo()
        this.dialogVisible1 = false
      })
    },
    uploadFileSchool() { },
    handleRemove(file) {
      console.log(file, 1621323)
      this.xmOrderInfo.in_remark_img.splice(
        this.xmOrderInfo.in_remark_img.indexOf(file),
        1
      )
    },
    handleRemoveOut(file) {
      console.log(file)
      this.xmOrderInfo.out_remark_img.splice(
        this.xmOrderInfo.out_remark_img.indexOf(file),
        1
      )
    },
    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async handleChangeFileOut(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOssOut(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.imgList = res
          this.xmOrderInfo.in_remark_img = []
          this.imgList.map((item) => {
            this.xmOrderInfo.in_remark_img.push({
              url: item.url,
            })
          })
          this.uploadFileTime = false
        }
      )
    },
    async uploadFileOssOut(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.imgList = res
          this.xmOrderInfo.out_remark_img = []
          this.imgList.map((item) => {
            this.xmOrderInfo.out_remark_img.push({
              url: item.url,
            })
          })
          this.uploadFileTime = false
        }
      )
    },

    handleRemove1(file) {
      console.log(file, 1621323)
      // this.xmOrderInfo.xmOrderPayRecordArr[0].proof_img.splice(this.xmOrderInfo.xmOrderPayRecordArr[0].proof_img.indexOf(file), 1);
      this.imgList1.splice(this.imgList1.indexOf(file), 1)
    },
    async handleChangeFile1(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss1(fileList)
      }
    },
    async uploadFileOss1(list) {
      this.uploadFileTime = true
      await uploadFileSchool(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.imgList2 = res
          this.imgList1 = []
          this.imgList2.map((item) => {
            this.imgList1.push({
              url: item.url,
            })
          })
          // console.log(this.xmOrderInfo.xmOrderPayRecordArr[0].proof_img, 4654623);

          this.uploadFileTime = false
        }
      )
    },

    showEdit() {
      this.dialogVisible1 = true
    },
    getXmOrderInfo() {
      getXmOrderInfo({
        xm_order_id: this.xm_order_id,
      }).then((res) => {
        console.log(res, 1214645)
        this.cancelList = []
        this.cancelList.push({
          disable_user_realname: res.xmOrderInfo.disable_user_realname,
          disable_type: res.xmOrderInfo.disable_type,
          disable_date: res.xmOrderInfo.disable_date,
          disable_remark: res.xmOrderInfo.disable_remark,
        })
        if (res.xmOrderInfo.disable_date === null) {
          this.isShowcancel = false
        } else {
          this.isShowcancel = true
        }
        console.log(this.cancelList, 7695623)
        this.xmOrderInfo = res.xmOrderInfo

        this.xmOrderGoodsArr = []
        this.xmOrderInfo.xmOrderGoodsArr.map((item) => {
          console.log(item, 7854656)
          this.xmOrderGoodsArr.push(item.id)
          console.log(this.xmOrderGoodsArr, 7854656)
        })
        console.log(this.xmOrderInfo, 1214645)
        if (this.xmOrderInfo.type === 2) {
          console.log(this.xmOrderInfo, 45565)
          this.xmOrderInfo.xmOrderGoodsArr.map((item) => {
            if (item.bussiness_type === 4) {
              this.TransferOutInformation.push(item)
            }
            if (item.bussiness_type === 3) {
              this.TransferInformationList.push(item)
            }
          })
        }
        this.TransferOutInformation.map((item) => {
          this.sum1 += parseFloat(item.final_amount)
        })
        this.TransferInformationList.map((item) => {
          this.sum2 += parseFloat(item.final_amount)
        })
        this.xmOrderInfo.in_remark_img = JSON.parse(
          this.xmOrderInfo.in_remark_img || '[]'
        )
        this.xmOrderInfo.in_remark_img.forEach((imgItem, i) => {
          imgItem.name = '未命名-' + i + 1
        })
        this.xmOrderInfo.out_remark_img = JSON.parse(
          this.xmOrderInfo.out_remark_img || '[]'
        )
        this.xmOrderInfo.xmOrderGoodsArr.map((item) => {
          this.sum += parseFloat(item.total_amount)
        })
        if (this.xmOrderInfo.xmOrderPayRecordArr[0] === null) {
          this.imgList1 = []
          // this.xmOrderInfo.xmOrderPayRecordArr[0].proof_img = []
        } else {
          this.imgList1 = JSON.parse(
            this.xmOrderInfo.xmOrderPayRecordArr[0].proof_img
          )
          console.log(this.imgList1, 512323)
        }
      })
    },
    goBack() {
      this.$router.push({
        name: 'ordermanagement',
      })
    },
  },
}
</script>
<style scoped>
.translateMian {
  width: 100%;
  /* padding: 10px; */
}

.topBack {
  padding: 10px;
  width: 100%;
  background: #fff;
  border-radius: 5px;
}

.ordermanagementDetail {
  padding: 10px;
}

.main {
  background: #fff;
  min-height: calc(100vh - 135px);
  padding: 15px;
  border-radius: 5px;
  margin-top: 10px;
}

.boederBox {
  border: 1px solid #f5f0f0;
  padding: 15px;
  border-radius: 5px;
  position: relative;
}

.picIcon {
  position: absolute;
  width: 80px;
  height: 80px;
  top: -35px;
  right: -13px;
}

.boederBox1 {
  border: 1px solid #f4efef;
  padding: 15px;
}

.boederBox1 li {
  margin-bottom: 15px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

.borderpayment {
  width: 45%;
  margin-right: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 18px;
  border-radius: 5px;
  min-height: 50px;
}

/deep/ .bk .el-dialog__body {
  padding: 0px 20px;
}
</style>
